import { Box, Grid2 as Grid, Paper } from "@mui/material";
import Users from "./chat-list";
import AppointmentChatList from "./chat-list/AppointmentChatList";
import Chat from "./chat";
import { useLocation } from "react-router-dom";
import { useChatInitiate } from "../../../hooks/useChatInitiate";

function Messages({ isAppointmentChat = false }) {
  const { state } = useLocation()
  const { isActive, isGeneral, isAppointment } = useChatInitiate()

  const activeCondition = isAppointmentChat
    ? (isActive && isAppointment)
    : (isActive && isGeneral);

  return (
    <Grid container spacing={2} height="100%">
      {state === "test" && (isAppointmentChat ? <AppointmentChatList /> : <Users />)}
      {activeCondition ?
        <Chat isAppointmentChat={isAppointmentChat} /> :
        <Grid size={{ xs: 12, md: "grow" }}>
          <Paper
            sx={{
              p: 0,
              display: "grid",
              height: { xs: "520px", md: "580px" },
              maxHeight: "calc(100vh - 200px)",
              minHeight: "450px",
              gridTemplateRows: "auto 1fr auto"
            }}
            variant="outlined"
          >
            <Box />
            <Box
              sx={{
                fontSize: 20,
                display: "grid",
                fontWeight: "500",
                bgcolor: "#f0f0f0",
                placeContent: "center",
              }}
            >
              Select a chat
            </Box>
          </Paper>
        </Grid>
      }
    </Grid>
  );
}

export default Messages;